howspace.widgets.onEvent('discussion:categories:preview-generation:completed', (widget, notification) => {
    howspace.aiGen.clearPromptTimeout(widget);
    const modal = $('dialog[data-source-widget-type="' + notification.object.widget.type + '"][data-source-widget-id="' + notification.object.widget.id + '"]');

    modal.find('.howspace-loader').remove();
    modal.find('.categories').removeClass('d-none');
    real.button.reset(modal.find('.btn-success'));

    notification.object.categories.forEach(category => {
        modal.find('input[name="title{default}"]').last().val(category);

        if (category !== notification.object.categories[notification.object.categories.length - 1]) {
            modal.find('.add-category-btn').trigger('click');
        }
    });

    modal.find('.btn-success').trigger('focus');
});
